import { render, staticRenderFns } from "./BlogFeedWidget.vue?vue&type=template&id=45a43c0e&"
import script from "./BlogFeedWidget.vue?vue&type=script&lang=js&"
export * from "./BlogFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a43c0e')) {
      api.createRecord('45a43c0e', component.options)
    } else {
      api.reload('45a43c0e', component.options)
    }
    module.hot.accept("./BlogFeedWidget.vue?vue&type=template&id=45a43c0e&", function () {
      api.rerender('45a43c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/BlogFeedWidget.vue"
export default component.exports